import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import type { TermsAndConditionsBrand } from '~/consts/termsAndConditions';

import { SaveTermsAndConditionsBodyParams, saveTermsAndConditions } from '~/services/ContentService';

import { termsAndConditionsQueryKeys } from './termsAndConditionsQueryKeys';

interface SaveTermsAndConditionsParams {
  brand: TermsAndConditionsBrand;
  slug: string;
  body: SaveTermsAndConditionsBodyParams;
}

export function useSaveTermsAndConditions() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ brand, slug, body }: SaveTermsAndConditionsParams) => {
      return await saveTermsAndConditions(brand, slug, body);
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(
        termsAndConditionsQueryKeys.detail(variables.brand, variables.slug, variables.body.locale),
        data,
      );
      queryClient.invalidateQueries({ queryKey: termsAndConditionsQueryKeys.all });
      enqueueSnackbar(`Saved ${variables.slug} in ${variables.body.locale}`, { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error saving terms and conditions: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
